import React, { useEffect } from 'react';
import { Button } from 'app/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'app/components/ui/dialog';
import { Form } from 'app/components/ui/form';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { CategoriesForm } from '../form';
import { useCourseSlice } from '../../slice';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  Categoriesdata: any;
}

export function DialogUpdateProductCategories({
  isOpen,
  onOpenChange,
  Categoriesdata,
}: Props) {
  const form = useForm();

  const { useUpdateCourseCategoriesMutation } = useCourseSlice();
  const [updateProductCategories, { isLoading, error, data }] =
    useUpdateCourseCategoriesMutation();

  // Set form values from `Categoriesdata`
  useEffect(() => {
    if (Categoriesdata) {
      form.setValue('category_name', Categoriesdata.category_name);
      form.setValue('id', Categoriesdata.category_id);
      form.setValue('slug', Categoriesdata.slug);
      form.setValue('image', Categoriesdata.image);
      form.setValue(
        'parent_category_id',
        String(Categoriesdata.parent_category_id),
      );
    }
  }, [Categoriesdata, form]);

  // Form submission handler
  const onSubmit = values => {
    updateProductCategories(values)
      .unwrap()
      .then(response => {
        toast.success(response?.message || 'Category updated successfully');
        onOpenChange(false);
      })
      .catch(err => {
        console.error('Error updating category:', err);
        toast.error(err?.message || 'Failed to update category');
      });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Category</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <CategoriesForm />
            <DialogFooter>
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button type="submit" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save Changes'}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
